import React from 'react'
import { CustomErrorWrapper, CustomError } from './style'

export const ErrorBox = ({ msg, style }) => {
    return (
        <CustomErrorWrapper style={{ marginTop: '3px', ...style }}>
            <CustomError>{msg}</CustomError>
        </CustomErrorWrapper>
    )
}